import {Injectable} from '@angular/core';
import {SelectCommoditiesService} from './select-commodities.service';
import {MovementsModel} from '../../tyres/models/movements.model';
import {MovementsDetailModel} from '../../tyres/models/movements-detail.model';
import {PermissionService} from './permission.service';
import {PROFILE_TYRE_CUSTOMER_SERVICE_KEY, PROFILE_TYRE_FLEET_POOL_OPERATOR_KEY, PROFILE_TYRES_ADMIN_KEY, PROFILE_TYRES_ASSISTANCE_CENTER_KEY, PROFILE_TYRES_CENTER_SUPER_USER} from '../../permissions-variables';
import {CommodityModel} from '@shared/models/commodity.model';

@Injectable()
export class TyresCommoditiesService {

	constructor(public selectCommoditiesService: SelectCommoditiesService,
				public permission: PermissionService) {
	}

	isSource(movement: MovementsDetailModel | MovementsModel) {
		const current: CommodityModel = this.getCurrent();
		if (current != null) {
			return current.ald_commodity_id === movement.id_supplier_detail_source;
		}
		return false;
	}

	isDestination(movement: MovementsDetailModel | MovementsModel): boolean {
		return !this.isSource(movement);
	}

	getCurrent(): CommodityModel | null {
		const c: CommodityModel[] = this.selectCommoditiesService.getCurrentCommodities();
		if (c != null) {
			return c[0];
		}
		return null;
	}

	isCenterA(movement: MovementsDetailModel | MovementsModel): boolean {
		const checkPerm: boolean = this.permission.getCurrentUserPermissions().hasProfile([PROFILE_TYRES_ASSISTANCE_CENTER_KEY, PROFILE_TYRES_CENTER_SUPER_USER]);
		return this.isSource(movement) && checkPerm;
	}

	isCenterB(movement: MovementsDetailModel | MovementsModel): boolean {
		return !this.isSource(movement) &&
			this.permission.getCurrentUserPermissions().hasProfile([PROFILE_TYRES_ASSISTANCE_CENTER_KEY, PROFILE_TYRES_CENTER_SUPER_USER]);
	}

	isAld(): boolean {
		return this.permission.getCurrentUserPermissions().hasProfile([PROFILE_TYRES_ADMIN_KEY]);
	}

	isCustomerService(): boolean {
		return this.permission.getCurrentUserPermissions().hasProfile([PROFILE_TYRE_CUSTOMER_SERVICE_KEY]);
	}

	isPoolFleet(): boolean {
		return this.permission.getCurrentUserPermissions().hasProfile([PROFILE_TYRE_FLEET_POOL_OPERATOR_KEY]);
	}

}
